<template>
  <v-app id="openpaas">
    <a href="#main-content" class="summary-link sr-only">{{ $t("Skip to main content") }}</a>
    <div v-if="$auth.ready()">
      <!-- Header section with role="banner" -->
      <header role="banner">
        <v-toolbar
          app
          light
          color="white"
          :fixed="toolbar.fixed"
          :clipped-left="toolbar.clippedLeft"
          :clipped-right="toolbar.clippedRight"
          v-if="$auth.check()"
          :class="hidden ? 'hidden toolbar elevation-2' : 'toolbar elevation-2'"
        >
          <v-toolbar-title class="d-flex align-center">
            <v-toolbar-side-icon
              v-if="$auth.check() && !hidden"
              class="mx-2 smartsla-logo"
              @click.stop="toggleDrawer()"
              v-show="$vuetify.breakpoint.width <= '768'"
              :title="`${$t('Toggle menu')}`"
            ></v-toolbar-side-icon>

            <router-link v-if="!hidden" :to="{ name: routeNames.REQUESTS }" class="mx-2 smartsla-logo">
              <v-img
                contain
                width="160"
                max-height="38"
                class="hidden-sm-and-down"
                :src="logo"
                :alt="`${$t('Logo')} ${defaultCompany.name}`"
              />
              <v-img
                contain
                width="140"
                max-height="30"
                class="hidden-md-and-up"
                :src="logo"
                :alt="`${$t('Logo')} ${defaultCompany.name}`"
              />
            </router-link>
          </v-toolbar-title>

          <v-spacer v-if="!hidden"></v-spacer>

          <v-slide-x-reverse-transition>
            <global-search
              class="mx-2"
              v-if="$auth.check()"
              v-show="hidden || !isMobile"
              :isMobile="isMobile"
              :hidden="hidden"
              @updated-hidden="getHiddenValue"
              role="searchbar"
              aria-label="search"
            />
          </v-slide-x-reverse-transition>
          <v-spacer v-if="!hidden"></v-spacer>

          <v-btn
            v-if="isMobile && $auth.check() && !hidden"
            icon
            @click="hidden = !hidden"
            :title="`${$t('Toggle search')}`"
          >
            <v-icon
              >search<span class="sr-only">{{ $t("search") }}</span></v-icon
            >
          </v-btn>

          <user-menu v-if="$auth.check() && !hidden" :title="$t('UserMenu')" :aria-label="$t('UserMenu')" />
        </v-toolbar>
        <logged-main-navigation v-if="$auth.check()" />
      </header>

      <!-- Main content area with role="main" -->
      <v-content role="main">
        <v-container fluid fill-height :class="isMobile ? 'px-1' : ''">
          <v-layout row justify-center align-center>
            <!-- Content will be injected here -->
            <router-view :key="$route.fullPath" />
          </v-layout>
        </v-container>
      </v-content>
      <FooterLinks :displayAsFooter="false" />
    </div>

    <!-- Loading screen -->
    <v-layout align-center justify-center row fill-height v-else>
      <v-progress-circular indeterminate :size="70" color="primary"></v-progress-circular>
    </v-layout>

    <!-- Snackbar notifications -->
    <snackbar />
  </v-app>
</template>

<script>
import { routeNames } from "@/router";
import ApplicationSettings from "@/services/application-settings";
import UserMenu from "@/components/UserMenu";
import LoggedMainNavigation from "@/components/LoggedMainNavigation";
import Snackbar from "@/components/Snackbar";
import GlobalSearch from "@/components/search/GlobalSearch.vue";
import FooterLinks from "@/components/FooterLinks.vue";

export default {
  metaInfo() {
    return {
      title: this.defaultCompany.name,
      htmlAttrs: {
        lang: this.$i18n.locale
      }
    };
  },
  components: {
    UserMenu,
    LoggedMainNavigation,
    Snackbar,
    GlobalSearch,
    FooterLinks
  },
  data: () => ({
    hidden: false
  }),
  computed: {
    routeNames() {
      return routeNames;
    },
    defaultCompany() {
      return ApplicationSettings.SUPPORT_ACCOUNT;
    },
    logo() {
      return require("@/assets/" + this.defaultCompany.logo);
    },
    toolbar() {
      return this.$store.state.ui.toolbar;
    },
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
        case "md":
        case "lg":
        case "xl":
          return false;
      }
    }
  },
  methods: {
    toggleDrawer() {
      this.$store.dispatch("ui/toggleDrawer", "drawerLeft");
    },
    getHiddenValue(event) {
      this.hidden = event;
    }
  },
  created() {
    this.$auth.ready(() => {
      this.$store.dispatch("currentUser/fetchUser");
    });
  }
};
</script>

<style lang="stylus">
openpaas-login-color = #1656a5

.white-color {
  color: #ffffff !important;
}

.white-background-color {
  background-color: #ffffff !important;
}

.grey-color {
  color: #e0e0e0 !important;
}

.grey-background-color {
  background-color: #e0e0e0 !important;
}

.blue-color {
  color: #2195f2 !important;
}

.blue-background-color {
  background-color: #2195f2 !important;
}

.green-color {
  color: #76c43d !important;
}

.green-background-color {
  background-color: #76c43d !important;
}




.file-upload .input-wrapper {
  background-color: #eee !important;
  height: 45px !important;
  width: 175px !important;
  margin-left: 10px !important;
}

.file-upload .input-wrapper .file-upload-label {
  color: rgba(0, 0, 0, 0.54) !important;
  padding-left: 0px !important;
}

.file-upload .input-wrapper .file-upload-label .file-upload-icon {
  float: left !important;
  font-size: 30px !important;
}

.file-upload .input-wrapper:hover {
  background-color: #eee !important;
}

.v-icon.arrow-down.pr-4.material-icons.theme--light.blue--text,
.v-icon.arrow-down.pr-5.pt-2.material-icons.theme--light.blue--text {
  font-size: 36px !important;
}

.v-list--three-line .v-list__tile {
  margin-top: 10px !important;
}

.user-menu-item {
  margin-left: 20%;
}

th.column.sortable.text-xs-left {
  padding: 15px !important;
}

.requests-list th.column.text-xs-left, .requests-list th.column.text-xs-center, .requests-list th.column.text-xs-right {
  padding: 15px !important;
}

#tab-contributions[aria-selected="false"] a {
  color: #666 !important;
}

#openpaas .theme--light.v-chip a {
  color: rgba(0,0,0,0.87);
}
#openpaas .grey.lighten-4 a {
  color: #2F71C4;
}

.login-bar {
  background-color: openpaas-login-color;
}

#login-page button.v-btn.theme--light {
  background-color: openpaas-login-color !important;
  color: #fff;
}
#openpaas #login-page .v-btn .v-btn__content { color: #fff; }

th {
  background-color: #ffffff;
}
tbody th {
  background: initial;
}

tr:nth-child(even) {
  background-color: #ffffff;
}

tr:nth-child(odd) {
  background-color: #F9F9F9;
}

.layout.justify-center.align-center > div {
  width: 100%;
  padding: 0px !important;
}


.ql-container {
  background: #FAFAFA;
}

form #app .flex.pa-3.xs12.md6 {
  margin: 0px !important;
  padding: 0px !important;
  max-width: 100% !important;
  width: 100% !important;
  display: contents !important;
  clear: both !important;
}

form #app .layout.row.wrap {
  display: block !important;
}

form #app {
  border: solid 1Px #ccc;
  min-height: 600px !important;
}

form #app textarea {
  min-height: 300px !important;
  border: solid 1Px #ccc;
  padding: 10px;
  margin: 0px;
}

form #app .v-text-field__slot {
  padding: 0px;
  margin: -5px;
}

form #app .v-icon.v-icon--link.material-icons.theme--light {
  padding: 10px;
}

.v-btn.v-btn--floating.v-btn--router.v-btn--small.theme--dark.primary {
  box-shadow: 0px 0px;
}

.v-card__actions {
  padding-bottom: 24px !important;
}

.container {
  max-width: 100% !important;
}

.required-element label::after, .required-label::after {
  margin-left: 0.5em;
  content: '*';
  color: #ED0E06;
}

.v-input__append-outer {
  height: 48px;
  display: block !important;
  padding: 0px !important;
  margin: 0px !important;
}

.v-navigation-drawer > .v-list .v-list__tile--active.primary--text {
  border: 2px solid ;
  background: #1175e2 !important;
  color: #fff !important;
}
.v-list__tile--active .v-list__tile__action:first-of-type .v-icon,
.v-navigation-drawer > .v-list .v-list__tile--active .v-list__tile__title {
  color: #fff !important;
}
.v-list__tile.v-list__tile--link.theme--light {
  border: 1px solid transparent;
  border-right-width: 5px;
}
.v-list__tile.v-list__tile--link.theme--light:hover,
.v-list__tile.v-list__tile--link.theme--light:focus-visible {
  border-color: inherit ;
}

/* Focus styles */
.toolbar .v-btn:focus-visible,
.user-menu-list .v-list__tile--highlighted,
.v-autocomplete__content .v-list__tile--highlighted,
.upload-btn:focus-within,
*:focus-visible {
  outline: 2px solid #f00 !important;
  outline-offset: -3px !important;
  box-shadow: inset 0px 0px 0 4px #fff !important;
}
*:focus:not(:focus-visible) {
  outline-color: transparent !important;
}
input:focus-visible {
  outline-offset: 0px !important;
}
.user-menu-item:focus-visible {
  outline-offset: 1px !important;
}
.user-menu-toggler:focus-visible {
  outline-offset: 0px !important;
}
.toolbar .v-btn:focus-visible {
  outline-offset: 2px !important;
}

/* Search fields */
.layout.filter_layout .v-input__slot:focus-within,
.v-autocomplete .v-input__slot:focus-within {
  border: 2px solid #1175e2 !important;
}
.layout.filter_layout .v-input__slot:focus-within input,
.v-autocomplete .v-input__slot:focus-within input {
  outline: 0px solid #f00 !important;
}

nav .smartsla-logo {
  padding: 4px;
}

/* Accessibility helper classes */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.sr-only:focus-visible {
  position: initial;
  width: initial;
  height: initial;
  padding: initial;
  margin: initial;
  clip: initial;
  border: initial;
  overflow: initial;
}
.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}

[role="button"] {
  cursor: pointer;
}

/* SR nav links */
.summary-link,
.summary-link.sr-only:focus-visible { z-index: 4; position: absolute; }


/* BEGIN Accessible colors: contrast ratio should be sufficient for text and visual elements */
#openpaas .primary {
  background-color: #1565c0 !important;
  border-color: #1565c0 !important;
}

#openpaas a {
  color: #0758a6;
}
#openpaas .v-btn .v-btn__content {
  color: #0758a6;
}
#openpaas .v-btn.blue-background-color.white-color .v-btn__content {
  color: white;
}
#openpaas .primary .v-btn__content {
  color: white;
}
#openpaas .btn-submit .v-btn__content {
  color: white;
}

#openpaas .grey--text {
  color: #767676 !important;
  caret-color: #767676 !important;
}
#openpaas .grey.lighten-4 .grey--text {
  color: #707070 !important;
  caret-color: #6d6d6d !important;
}

#openpaas .theme--light.v-stepper .v-stepper__label {
  color: #767676;
}
#openpaas .theme--light.v-stepper .theme--light.v-icon {
  font-weight: bold;
}

#openpaas .success {
  background-color: #418545 !important;
	border-color: #418545 !important;
}
#openpaas .success--text {
  color: #418545 !important;
  caret-color: #418545 !important;
}
#openpaas .info {
  background-color: #1c7db7 !important;
}

#openpaas .blue-color {
  color: #0758a6 !important;
}
/* Doubling the class makes it a stronger selector */
#openpaas .criticality.sensible.sensible {
  background-color: #AE650B;
}
#openpaas .warning--text {
  color: #AE650B !important;
  caret-color: #AE650B !important;
}
#openpaas .v-datatable__actions__range-controls button .v-btn__content .v-icon {
	font-weight: bold;
	/* color: #767676 !important; */
}
#openpaas .theme--light.v-breadcrumbs .v-breadcrumbs__divider,
#openpaas .theme--light.v-breadcrumbs .v-breadcrumbs__item--disabled {
  color: #737373;
}
#openpaas .contracts-search-span.contracts-search-span {
  color: #727272;
}
#openpaas .error {
  background-color: #ED0E06 !important;
  border-color: #ED0E06 !important;
}
#openpaas .error--text {
  color: #ED0E06 !important;
  caret-color: #ED0E06 !important;
}

#openpaas .v-btn-toggle .v-btn__content {
  color: black;
}
#openpaas .v-btn.theme--light.error .v-btn__content {
  color: #fff;
}
#openpaas .v-btn.theme--light.success .v-btn__content {
  color: #fff;
}

#openpaas .primary--text,
.v-label.theme--light.v-label--active.primary--text {
  color: #1175E2 !important;
}

#login-page input#login::placeholder,
.theme--light.v-input input::placeholder {
  color: #707070;
}


/* END Accessible colors */


/* Table filters */
.column.sortable.text-xs-left .v-icon {
  color: #767676 !important;
  opacity: 1 !important;
}
.column.sortable.text-xs-left:focus .v-icon {
  color: #1b1b1b !important;
  font-weight: bold;
}

/* Modals */
.v-dialog .light-blue,
.light-blue {
  background-color: #037FB0 !important;
  border-color: #037FB0 !important;
}
.v-dialog .v-toolbar__content button:focus-visible {
  outline-offset: 2px !important;
  border: 2px solid white;
}
nav.theme--dark .v-btn .v-btn__content .mdi-close::before {
  color: white;
}
.theme--light.v-label {
  color: rgba(0,0,0,0.55);
}
.v-snack__content .v-btn__content {
  color: white;
  font-weight: bold;
}
#openpaas .v-snack .v-btn .v-btn__content {
  color: #fff;
}

/* Public pages */
#page-terms h1,
#page-accessibility h1,
#page-privacy h1 {
  margin: 0 0 .75em 0;
  padding: 0;
}
#page-terms h2,
#page-accessibility h2,
#page-privacy h2 {
  margin: 1em 0 .35em 0;
  padding: 0;
}
#page-terms h3,
#page-accessibility h3,
#page-privacy h3 {
  margin: 1em 0 .3em 0;
  padding: 0;
}
#page-terms h4,
#page-accessibility h4,
#page-privacy h4 {
  margin: .75em 0 .25em 0;
  padding: 0;
}
#page-terms h5,
#page-accessibility h5,
#page-privacy h5 {
  margin: .5em 0 .2em 0;
  padding: 0;
}
#page-terms h6,
#page-accessibility h6,
#page-privacy h6 {
  margin: .5em 0 .15em 0;
  padding: 0;
}
#page-terms p,
#page-accessibility p,
#page-privacy p {
  margin: .5em 0 .15em 0;
  padding: 0;
}
#page-terms ul,
#page-accessibility ul,
#page-privacy ul {
  margin: 0.25em 0 0.5em 0;
  padding: 0 0 0 2em;
}

#page-terms .container,
#page-accessibility .container,
#page-privacy .container {
  width: 80%;
  min-width: 36em;
  max-width: 90%;
  padding: 0;
}

@media screen and (max-width: 780px) {
  #page-terms .container,
  #page-accessibility .container,
  #page-privacy .container {
      min-width: initial;
    max-width: initial;
    padding: 0;
    margin: 0 1rem;
    width: auto;
  }
}

@media only screen and (min-width: 1264px) {
  .file-upload .input-wrapper {
    width: 175px !important;
  }
}

.v-toolbar__content {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.v-card.v-sheet.theme--light p {
  margin-bottom: 0px;
}

.v-btn__content {
  width: 100% !important;
}

.cust_uploader .v-list.theme--light {
  padding: 0px !important;
}
</style>
